<template>
  <v-toolbar class="topToolbar " fixed color="primary" dark :style="'opacity:'+(offsetTop*3)*.01+'; box-shadow: 1px 1px 2px rgba(0,0,0,.16)'" >

        <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->
        <v-toolbar-title  class="white--text dinpro-regular font-weight-light" >
         {{ $route.meta.title }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

       <v-btn icon ripple to="/search">
          <v-icon color="lighten-1">mdi-magnify</v-icon>
        </v-btn>

       <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon> 

  </v-toolbar>

  <v-navigation-drawer
        v-model="drawer"
        location="right"
        temporary
      >
        <v-list
          :items="items"
        ></v-list>
  </v-navigation-drawer>




</template>

<script>
export default {
  name: "Toolbar",
  data: () => ({
     drawer: false,
     items: [
        {
          title: 'Foo',
          value: 'foo',
        },
        {
          title: 'Bar',
          value: 'bar',
        },
        {
          title: 'Fizz',
          value: 'fizz',
        },
        {
          title: 'Buzz',
          value: 'buzz',
        },
      ],
  }),
};


</script>
